import { useRef, useState } from "react";
import { Modal } from "./Modal";
import { Button } from "./Button";

export interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  message: string;
  confirmLabel?: string;
  variant?: "danger" | "primary";
}

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Confirmar",
  variant = "primary",
}: ConfirmDialogProps) {
  const confirmingRef = useRef(false);
  const [confirming, setConfirming] = useState(false);

  const handleConfirm = async () => {
    if (confirmingRef.current) return;

    confirmingRef.current = true;
    setConfirming(true);

    try {
      await onConfirm();
      onClose();
    } finally {
      confirmingRef.current = false;
      setConfirming(false);
    }
  };

  const handleClose = () => {
    if (!confirmingRef.current) onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      footer={
        <>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={confirming}
          >
            Cancelar
          </Button>

          <Button
            variant={variant === "danger" ? "danger" : "primary"}
            onClick={handleConfirm}
            loading={confirming}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-[#2C2C2C]">{message}</p>
    </Modal>
  );
}